import { render, staticRenderFns } from "./ComplianceReport.vue?vue&type=template&id=1fc944f6&scoped=true&"
import script from "./ComplianceReport.vue?vue&type=script&lang=js&"
export * from "./ComplianceReport.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceReport.vue?vue&type=style&index=0&id=1fc944f6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc944f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VIcon,VRow,VSpacer})
